import { AxiosInstance } from 'axios';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { PaginatedResults } from '@trukt/types/PaginatedResults';

import { CaseLabel } from '@trukt/types/CaseLabel';

export interface CaseLabelsSearchRequest extends Omit<PaginatedQueryParams, 'order'> {
  popular?: boolean;
  isDeprecated?: boolean;
  order?: 'asc' | 'desc';
}

export type CaseLabelsSearchResponse = PaginatedResults<CaseLabel>;

export class CaseService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  searchLabels(request: CaseLabelsSearchRequest) {
    return this.instance.get<CaseLabelsSearchResponse>('/case/labels', {
      params: request,
    });
  }
}
